<template>
  <SharedFolderItemList
    class="sharedFolderItemList"
    data-test-id="PasswordManager_SharedFolderItemList"
  />
</template>

<script>
import SharedFolderItemList from 'client/PasswordManager/SharedFolders/SharedFoldersItemList.vue';

export default {
  name: 'PasswordManagerSharedFolders',

  components: {
    SharedFolderItemList,
  },
};
</script>

<style scoped>
.sharedFolderItemList {
  height: 100%;
}
</style>
